import { assetPath } from "@/lib/assets";

export type ProjectLink = {
  label: string;
  href: string;
};

export type Project = {
  title: string;
  summary: string;
  description: string;
  year: number;
  tags: string[];
  cover: {
    src: string;
    alt: string;
  };
  links: ProjectLink[];
};

export const projects = [
  {
    title: "CaiRL Research Toolkit",
    summary: "Anvendte eksperimenter med forsterkende læring, sikkerhet og pålitelighet.",
    description:
      "Et kuratert forskningsverktøy for å bygge, kjøre og sammenligne eksperimenter med forsterkende læring, der sikkerhet, etterprøvbarhet og praktisk nytte teller like mye som rå ytelse.",
    year: 2026,
    tags: ["Forskning", "AI", "Rust"],
    cover: {
      src: assetPath("/project-covers/cairl.svg"),
      alt: "Lagvis diagram for forsterkende læring",
    },
    links: [{ label: "Publikasjoner", href: "#publications" }],
  },
  {
    title: "UiA-infrastruktur",
    summary: "Driftssystemer, undervisningsstøtte og robuste lokale tjenester.",
    description:
      "Infrastruktur- og automatiseringsarbeid rundt undervisning og forskningsflyt ved UiA, med vekt på stabile tjenester, observerbar oppførsel og løsninger som kan vedlikeholdes over tid.",
    year: 2025,
    tags: ["Infrastruktur", "Undervisning"],
    cover: {
      src: assetPath("/project-covers/uia-infra.svg"),
      alt: "Sammenkoblede infrastrukturnoder",
    },
    links: [{ label: "UiA", href: "https://www.uia.no/english/about-uia/employees/perara12/" }],
  },
  {
    title: "Tsetlin RL Experiments",
    summary: "Utforskende arbeid i møtet mellom Tsetlin-maskiner og lærende agenter.",
    description:
      "Eksperimenter som kobler tolkbare maskinlæringsideer med agentatferd, med mål om å gjøre beslutningsprosesser enklere å inspisere, forklare og diskutere.",
    year: 2024,
    tags: ["Forskning", "AI"],
    cover: {
      src: assetPath("/project-covers/tsetlin.svg"),
      alt: "Binært automatnett",
    },
    links: [{ label: "Publikasjoner", href: "#publications" }],
  },
  {
    title: "poengtavla.no",
    summary: "En lett poengtavle for arrangementer, undervisning og felles økter.",
    description:
      "Et fokusert webverktøy for å holde oversikt over poeng i felles situasjoner, uten at brukerne må gjennom et tungt administrasjonsgrensesnitt.",
    year: 2024,
    tags: ["Web", "Undervisning"],
    cover: {
      src: assetPath("/project-covers/poengtavla.svg"),
      alt: "Blokker fra et poengtavlegrensesnitt",
    },
    links: [{ label: "Demo", href: "https://poengtavla.no" }],
  },
  {
    title: "fps-counter",
    summary: "Lite ytelsesverktøy for å undersøke bildeflyt og responstid.",
    description:
      "Et kompakt verktøyprosjekt for å måle visuell ytelse og gjøre bildefrekvens synlig mens interaktive systemer finjusteres.",
    year: 2023,
    tags: ["Verktøy", "Ytelse"],
    cover: {
      src: assetPath("/project-covers/fps-counter.svg"),
      alt: "Graf for bildeflyt",
    },
    links: [],
  },
  {
    title: "per-arne.no",
    summary: "Denne spesifikasjonsdrevne nettsiden og publikasjonssporingen.",
    description:
      "Et modulært Rust- og React-system som gjør profilinnhold og akademiske kildedata om til en rask, selvdrevet offentlig profil.",
    year: 2026,
    tags: ["Web", "Rust", "Infrastruktur"],
    cover: {
      src: assetPath("/project-covers/per-arne-no.svg"),
      alt: "Systemkart for personlig nettside",
    },
    links: [{ label: "Publikasjoner", href: "#publications" }],
  },
] satisfies Project[];

export const projectTags = Array.from(new Set(projects.flatMap((project) => project.tags))).sort();
